import React, { PureComponent, Fragment } from 'react';
import { Button, FormGroup, ControlLabel } from 'react-bootstrap';
import { isUndefined } from 'lodash';
import { Select } from '@components/common';
import { DateTimePicker } from '@components';
import ReportFiltersForm from '@contexts/reportFilters';
import { reportTypes } from '@config';

export default class ReportFilter extends PureComponent {
	render() {
		return (
			<ReportFiltersForm.Consumer>
				{({
					loading : {
						coordinator : loadingCoordinators,
						officer : loadingOfficers,
						location : loadingLocations,
					},
					form : {
						coordinatorId, officerId, locationId, fromDate, toDate,
					},
					selectOptions : { coordinator, officer, location },
					applyFilters, clearFilters, changeReportType, onFilterChange, reportType, selectors,
				}) => (
					<Fragment>
						<div className="flex padding-bottom-20">
							<span className="flex-1 font-size-16 font-bold color-dark">Filter</span>
							<Button
								onClick={clearFilters}
								bsStyle="link"
								className="font-size-12 font-light"
							>
								Clear
							</Button>
						</div>
						<FormGroup className="margin-bottom-25">
							<ControlLabel>Report Type</ControlLabel>
							<Select
								value={reportType}
								name="reportType"
								onChange={changeReportType}
								options={reportTypes}
							/>
						</FormGroup>
						<If condition={selectors.includes('coordinator')}>
							<FormGroup className="margin-bottom-25">
								<ControlLabel>Coordinator</ControlLabel>
								<Select
									value={coordinatorId}
									name="coordinatorId"
									onChange={onFilterChange('coordinatorId')}
									options={coordinator}
									isLoading={loadingCoordinators}
									isClearable
								/>
							</FormGroup>
						</If>
						<If condition={selectors.includes('officer')}>
							<FormGroup className="margin-bottom-25">
								<ControlLabel>Officer</ControlLabel>
								<Select
									value={officerId}
									name="officerId"
									onChange={onFilterChange('officerId')}
									options={officer}
									isLoading={loadingOfficers}
									isClearable
								/>
							</FormGroup>
						</If>
						<If condition={selectors.includes('location')}>
							<FormGroup className="margin-bottom-25">
								<ControlLabel>Location</ControlLabel>
								<Select
									value={locationId}
									name="locationId"
									onChange={onFilterChange('locationId')}
									options={location}
									isLoading={loadingLocations}
									isClearable
								/>
							</FormGroup>
						</If>
						<If condition={selectors.includes('startDate')}>
							<DateTimePicker
								options={
									{ label : 'Start Date' }
								}
								value={fromDate}
								name="fromDate"
								onChange={onFilterChange('fromDate')}
								isClearable
							/>
						</If>
						<If condition={selectors.includes('endDate')}>
							<DateTimePicker
								options={
									{ label : 'End Date' }
								}
								value={toDate}
								name="toDate"
								onChange={onFilterChange('toDate')}
							/>
						</If>
						<Button
							onClick={applyFilters}
							bsStyle="primary"
							className="width-all"
							disabled={isUndefined(reportType) || (reportType === 5 && !locationId) || (reportType === 3 && !officerId)}
						>
							Apply Filters
						</Button>
					</Fragment>
				) }
			</ReportFiltersForm.Consumer>

		);
	}
}
